import { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { Menu, X } from 'lucide-react';
import { NAV_LINKS } from '../../utils/constants';
import SectionLink from './SectionLink';

// Nav items shown in the bar (Contact is handled by the "Open inbox" CTA).
const NAV_ITEMS = NAV_LINKS.filter((l) => l.id !== 'contact');

const RedesignHeader = () => {
  const [scrolled, setScrolled] = useState(false);
  const [menuOpen, setMenuOpen] = useState(false);

  useEffect(() => {
    const on = () => setScrolled(window.scrollY > 28);
    window.addEventListener('scroll', on, { passive: true });
    on();
    return () => window.removeEventListener('scroll', on);
  }, []);

  const closeMenu = () => setMenuOpen(false);

  return (
    <header className={`site-header ${scrolled ? 'is-scrolled' : ''}`}>
      <div className="r-wrap">
        <div className="site-header-inner">
          <Link to="/" className="brand" onClick={closeMenu}>
            <img src="/logo1.svg" alt="Feral Techlabs" className="brand-logo" />
            <span className="brand-word"><span className="f">FERAL</span><span className="t">TECHLABS</span></span>
            <span className="brand-tag">/ 2026</span>
          </Link>

          <nav className="header-nav" aria-label="Primary">
            {NAV_ITEMS.map((item) => (
              <SectionLink key={item.id} href={item.href}>{item.name}</SectionLink>
            ))}
          </nav>

          <div className="header-right">
            <SectionLink
              href="#contact"
              className="header-cta"
              aria-label="Open contact inbox"
            >
              <span className="dot" />
              <span>Open inbox</span>
            </SectionLink>
            <button
              type="button"
              className="header-icon-btn header-burger"
              onClick={() => setMenuOpen((v) => !v)}
              aria-label={menuOpen ? 'Close menu' : 'Open menu'}
              aria-expanded={menuOpen}
            >
              {menuOpen ? <X className="w-5 h-5" /> : <Menu className="w-5 h-5" />}
            </button>
          </div>
        </div>

        {menuOpen && (
          <div className="header-mobile">
            {NAV_ITEMS.map((item) => (
              <SectionLink key={item.id} href={item.href} onClick={closeMenu}>
                {item.name}
              </SectionLink>
            ))}
            <SectionLink href="#contact" onClick={closeMenu}>Contact</SectionLink>
          </div>
        )}
      </div>
    </header>
  );
};

export default RedesignHeader;
